export const mainNav = [
  { label: "Ingrédients", to: "/ingredients" },
  { label: "Le Domaine", to: "/domaine" },
  { label: "Savoir-faire", to: "/savoir-faire" },
  { label: "Qualité & réglementaire", to: "/qualite" },
  { label: "Journal", to: "/journal" },
];

export const footerNav = [
  {
    title: "Ingrédients",
    links: [
      { label: "Huiles essentielles", to: "/ingredients" },
      { label: "Hydrolats", to: "/ingredients" },
      { label: "Huiles végétales", to: "/ingredients" },
      { label: "Extraits CO₂", to: "/ingredients" },
      { label: "Sur-mesure", to: "/ingredients" },
    ],
  },
  {
    title: "Domaine",
    links: [
      { label: "Notre histoire", to: "/domaine" },
      { label: "Savoir-faire", to: "/savoir-faire" },
      { label: "Engagements RSE", to: "/domaine" },
      { label: "Journal", to: "/journal" },
    ],
  },
  {
    title: "Professionnels",
    links: [
      { label: "Demander un devis", to: "/#devis" },
      { label: "Qualité & réglementaire", to: "/qualite" },
      { label: "Échantillons", to: "/contact" },
      { label: "Contact", to: "/contact" },
    ],
  },
];
